module.exports = __webpack_public_path__ + "img/couples-036.405c329d.jpg";